import {isUsingKeycloak, readAccessToken, tryReauthenticatingExpiredSession} from '../authentication/authentication';
import {apiEndpoint, apiUrl, isTest} from './api';

export {apiEndpoint, apiUrl, isTest};

const shouldRefreshForStatus = (status) => {
  if (isUsingKeycloak()) {
    return status === 401 || status === 403;
  }

  return status === 401;
};

const reportApiError = (error) => console.error('API request error. We could be offline.', error);

const withFreshAccessToken = async (buildRequest) => {
  const actualRequest = async () => {
    const accessToken = await readAccessToken();
    return buildRequest(accessToken);
  };

  try {
    const response = await actualRequest();
    if (shouldRefreshForStatus(response.status) && await tryReauthenticatingExpiredSession()) {
      return await actualRequest();
    }

    return response;
  } catch (error) {
    if (isUsingKeycloak() && await tryReauthenticatingExpiredSession()) {
      return await actualRequest();
    }

    throw error;
  }
};

export const get = async (url) => {
  try {
    const response = await withFreshAccessToken((accessToken) =>
      fetch(apiEndpoint(url), {
        headers: new Headers({
          'Authorization': `Bearer ${accessToken}`
        })
      })
    );

    switch (response.status) {
      case 200:
        localStorage.loginRequired = false;
        if (url.includes('file/')) {
          return await response.blob();
        } else {
          return await response.json();
        }
      case 401:
      case 403:
        localStorage.loginRequired = true;
        return false;
      case 404:
        return false;
      default:
        return false;
    }

  } catch (error) {
    reportApiError(error);
    return false;
  }
}

export const put = async (url, params = {}) => {

  var formBody = [];
  for (var property in params) {
    var encodedKey = encodeURIComponent(property);
    var encodedValue = encodeURIComponent(params[property]);
    formBody.push(encodedKey + "=" + encodedValue);
  }
  formBody = formBody.join("&");

  try {
    const response = await withFreshAccessToken((accessToken) =>
      fetch(apiEndpoint(url), {
        method: 'PUT',
        headers: new Headers({
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': `Bearer ${accessToken}`
        }),
        body: formBody
      })
    );

    switch (response.status) {
      case 200:
        const json = await response.json();
        localStorage.loginRequired = false;
        return json;
      case 204:
        localStorage.loginRequired = false;
        return true;
      case 401:
      case 403:
        localStorage.loginRequired = true;
        return false;
      default:
        return false;
    }

  } catch (error) {
    reportApiError(error);
    return false;
  }
}

export const post = async (url, params = {}, ifFailsReturnError = false) => {

  var formBody = [];
  for (var property in params) {
    var encodedKey = encodeURIComponent(property);
    var encodedValue = encodeURIComponent(params[property]);
    formBody.push(encodedKey + "=" + encodedValue);
  }
  formBody = formBody.join("&");

  try {
    const response = await withFreshAccessToken((accessToken) =>
      fetch(apiEndpoint(url), {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': `Bearer ${accessToken}`
        }),
        body: formBody
      })
    );

    switch (response.status) {
      case 200:
        const json = await response.json();
        localStorage.loginRequired = false;
        return json;
      case 201:
        localStorage.loginRequired = false;
        return response.headers.get('Content-Location');
      case 401:
      case 403:
        localStorage.loginRequired = true;
        return false;
      case 400:
      case 500:
        return ifFailsReturnError ? response.json() : false;
      default:
        return false;
    }

  } catch (error) {
    reportApiError(error);
    return false;
  }
}

export const upload = async (url, params = {}) => {

  const body = new FormData();
  for (var property in params) {
    if (property === 'data') {
      if (params[property].uri) {
        const res = await fetch(params[property].uri);
        const blob = await res.blob();
        body.append(property, blob, params[property].name);
      } else {
        body.append(property, params[property].fileObj);
      }
    } else {
      body.append(property, params[property]);
    }
  }

  try {
    const response = await withFreshAccessToken((accessToken) =>
      fetch(apiEndpoint(url), {
        method: 'POST',
        headers: new Headers({
          // 'Content-Type': 'multipart/form-data', DOESN'T WORK
          'Authorization': `Bearer ${accessToken}`
        }),
        body
      })
    );

    switch (response.status) {
      case 200:
        const json = await response.json();
        localStorage.loginRequired = false;
        return json;
      case 201:
        localStorage.loginRequired = false;
        return response.headers.get('Content-Location');
      case 401:
      case 403:
        localStorage.loginRequired = true;
        return false;
      default:
        return false;
    }

  } catch (error) {
    reportApiError(error);
    return false;
  }
}
